import { RowContextMenuUI } from '../../../../../../view/design/dataTable/parts/rowContextMenu/domain/RowContextMenuUI';
import { DefaultRowContextMenu } from '../../../../../../view/design/dataTable/parts/rowContextMenu/view/DefaultRowContextMenu';
import { IRiskManagerQuestionFieldModel } from '../../../../service/question/field/IRiskManagerQuestionFieldModel';

export class RiskManagerQuestionFieldContextMenuUI<RowType> extends RowContextMenuUI<IRiskManagerQuestionFieldModel> {
  constructor(contextDomain) {
    super(contextDomain);
    this.defaultContextMenu.setValue({
      Component: DefaultRowContextMenu,
      id: 'default',
      properties: {
        event: null,
        isOpened: false,
        row: null,
      },
    });
  }
}
